import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-sla-management-solution',
  imports: [RouterModule, FeatureHero],
  templateUrl: './sla-management-solution.html',
  styleUrl: './sla-management-solution.scss',
})
export class SlaManagementSolution {

}
